/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'

const languages = [
  {
    lang: 'en',
    nameKey: 'MENU.LANGUAGE.ENGLISH',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'fa',
    nameKey: 'MENU.LANGUAGE.PERSIAN',
    flag: toAbsoluteUrl('/media/flags/iran.svg'),
  },
  {
    lang: 'ar',
    nameKey: 'MENU.LANGUAGE.ARABIC',
    flag: toAbsoluteUrl('/media/flags/saudi-arabia.svg'),
  },
  {
    lang: 'tr',
    nameKey: 'MENU.LANGUAGE.TURKISH',
    flag: toAbsoluteUrl('/media/flags/turkey.svg'),
  },
]

const Languages: FC = () => {
  const {t} = useTranslation()
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='right-start'
      data-kt-menu-flip='bottom'
    >
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
          {t('MENU.LANGUAGE')}
          <span className='fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
            {currentLanguage ? t(currentLanguage.nameKey) : ''}{' '}
            <img
              className='w-15px h-15px rounded-1 ms-2'
              src={currentLanguage?.flag}
              alt='metronic'
            />
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        {languages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
            onClick={() => {
              setLanguage(l.lang)
            }}
          >
            <a
              href='#'
              className={clsx('menu-link d-flex px-5', {active: l.lang === currentLanguage?.lang})}
            >
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt='metronic' />
              </span>
              {t(l.nameKey)}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
